<!--
 * @Author: vince
 * @Date: 2021-08-31 09:43:51
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2023-03-17 10:07:32
 * @Description:
-->
<template>
  <div v-loading="pageLoading">
    <el-form class="full-width mb-2px" :model="filterForm">
      <div class="filter-bar" type="flex">
        <el-form-item class="mb-none">
          <el-input
            size="small"
            v-model="filterForm.keyword"
            clearable
            placeholder="搜索教师姓名"
            style="width: 250px"
            @keydown.enter="refresh"
            @change="refresh"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-cascader
            size="small"
            v-model="filterForm.infoCode"
            :options="classifyList"
            :props="{ value: 'code', label: 'value', children: 'nodeList' }"
            @change="refresh"
            clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item class="mb-none">
          <el-date-picker
            size="small"
            v-model="filterForm.queryDate"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="refresh"
          ></el-date-picker>
        </el-form-item>
        <el-form-item class="mb-none" label="状态">
          <dic-selector
            size="small"
            checkAll
            @loaded="onCheckStatusLoaded"
            dicType="checkStatus"
            v-model="filterForm.checkStatus"
            @change="refresh"
          ></dic-selector>
        </el-form-item>

        <div class="space"></div>
        <!-- <el-button
          v-if="power(userInfo.menuInfoList, 'teachingTask-export')"
          type="primary"
          class="el-icon-upload2"
          size="small"
          @click="toExport"
          >导出</el-button
        > -->
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="onAdd"
          >新增</el-button
        >
      </div>
    </el-form>
    <el-table
      :data="tableData"
      @selection-change="onSelectionChange"
      style="width: 100%"
    >
      <el-table-column
        prop="declareTitle"
        label="申报项目"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="title"
        label="项目名称"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="teacherName"
        label="申报人"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="申报日期"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="declareDate"
        label="项目日期"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="score"
        label="对应积分"
        align="center"
      ></el-table-column>
      <el-table-column prop="checkStatus" label="状态" align="center">
        <template slot-scope="scope">
          <template>
            <el-tooltip
              v-if="scope.row.checkStatus == 2"
              :content="scope.row.checkDesc"
            >
              <span>{{ checkStatusFormatter(scope.row.checkStatus) }}</span>
            </el-tooltip>
            <span v-else>{{
              checkStatusFormatter(scope.row.checkStatus)
            }}</span>
          </template>
        </template></el-table-column
      >
      <el-table-column prop="attaches" label="项目证明" align="center">
        <template slot-scope="scope">
          <el-image
            fit="contain"
            v-if="scope.row.attaches"
            class="photo"
            style="height: 64px"
            :src="scope.row.attaches[0].url"
            :preview-src-list="scope.row.attaches.map((u) => u.url)"
          ></el-image>
          <el-image v-else class="photo">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column fixed="right" align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-button
            :disabled="
              !userInfo.roleCodes.includes('admin') &&
              userInfo.userId != scope.row.createBy
            "
            style="margin-right: 12px"
            @click="onEdit(scope.row)"
            type="text"
            size="small"
            >编辑</el-button
          >
          <el-popconfirm title="确定删除吗？" @confirm="onDel(scope.row)">
            <el-button
              :disabled="
                !userInfo.roleCodes.includes('admin') &&
                userInfo.userId != scope.row.createBy
              "
              slot="reference"
              type="text"
              class="danger"
              size="small"
              >删除</el-button
            >
          </el-popconfirm>
          <el-button
            :disabled="
              !userInfo.roleCodes.includes('admin') &&
              userInfo.userId != scope.row.createBy
            "
            v-if="power(userInfo.menuInfoList, 'examine-point-declare')"
            @click="onCheck(scope.row)"
            type="text"
            style="margin-left: 12px"
            size="small"
            >审批</el-button
          >
        </template>
      </el-table-column>
      <pagination
        class="mb-md mr-md"
        slot="append"
        :pageObj="filterForm"
      ></pagination>
    </el-table>
    <el-dialog
      title="新增积分申报项目"
      :visible.sync="dialogNewPointDeclare"
      @close="ondialogNewPointDeclareClose"
    >
      <el-form
        v-loading="saving"
        class="content-box"
        label-width="140px"
        ref="elpointDeclareForm"
        :model="pointDeclareForm"
        :rules="rules"
      >
        <el-form-item label="申报项目" prop="classifyTemp">
          <el-cascader
            v-model="pointDeclareForm.classifyTemp"
            :options="classifyList"
            :props="{ value: 'code', label: 'value', children: 'nodeList' }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="项目名称" prop="title">
          <el-input
            size="small"
            placeholder="请输入"
            v-model="pointDeclareForm.title"
            show-word-limit
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="申报人" prop="teacherTemp">
          <author-selector
            class="at"
            :multiple="false"
            v-model="pointDeclareForm.teacherTemp"
            :isReadOnly="userInfo.roleCodes == 'teacher'"
          ></author-selector>
        </el-form-item>
        <el-form-item label="项目日期" prop="declareDate" size="small">
          <el-date-picker
            v-model="pointDeclareForm.declareDate"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="项目日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="项目证明" prop="attaches">
          <uploader
            style="display: inline-block"
            tipDesc="仅支持图片"
            list-type="picture-card"
            :limit="1"
            accept="image/*"
            :maxSize="30 * 1024 * 1024"
            :file-list.sync="pointDeclareForm.attaches"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="dialogNewPointDeclare = false">取 消</el-button>
        <el-button type="primary" @click="onSave" :loading="saving"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="审批"
      :visible.sync="dialogCheck"
      @closed="ondialogCheckClose"
    >
      <el-row style="margin: 30px 0">
        <el-col :span="4">申报项目</el-col>
        <el-col :span="18">{{ checkData.declareTitle }}</el-col>
      </el-row>
      <el-row style="margin: 30px 0">
        <el-col :span="4">项目名称</el-col>
        <el-col :span="18">{{ checkData.title }}</el-col>
      </el-row>
      <el-row style="margin: 30px 0">
        <el-col :span="4">申报积分</el-col>
        <el-col :span="18">{{ checkData.score }}</el-col> </el-row
      ><el-row style="margin: 30px 0">
        <el-col :span="4">申报人</el-col>
        <el-col :span="18">{{ checkData.teacherName }}</el-col> </el-row
      ><el-row style="margin: 30px 0">
        <el-col :span="4">项目日期</el-col>
        <el-col :span="18">{{ checkData.declareDate }}</el-col> </el-row
      ><el-row style="margin: 30px 0">
        <el-col :span="4">申报日期</el-col>
        <el-col :span="18">{{ checkData.createTime }}</el-col>
      </el-row>
      <el-row style="margin: 30px 0">
        <el-col :span="4">申报证明</el-col>
        <el-col :span="18">
          <el-image
            :preview-src-list="[checkData.attaches]"
            :src="checkData.attaches"
            style="height: 100px"
          ></el-image>
        </el-col>
      </el-row>
      <el-form
        v-loading="saving"
        class="content-box"
        ref="elCheckForm"
        :model="elCheckForm"
        :rules="rules"
      >
        <el-form-item prop="checkStatus"
          ><el-radio-group v-model="elCheckForm.checkStatus">
            <el-radio label="1">通过</el-radio>
            <el-radio label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="checkDesc">
          <el-input
            v-if="elCheckForm.checkStatus == 2"
            v-model="elCheckForm.checkDesc"
            type="textarea"
            :rows="2"
          ></el-input> </el-form-item
      ></el-form>
      <div slot="footer" class="dialog-footer text-center">
        <el-button @click="dialogCheck = false">取 消</el-button>
        <el-button type="primary" @click="onSaveCheck" :loading="saving"
          >提 交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Uploader from '@/components/school/uploader.vue'
import { power } from '@/utils/index.js'
import { mapGetters, mapState } from 'vuex'
import Pagination from '../../components/Pagination.vue'
import AuthorSelector from '../../components/school/authorSelector.vue'
import DicSelector from '../../components/school/dicSelector.vue'
import { getData, postJson } from '../../http/fetch.js'
import { findPathToNodeId, flatKey } from '../../utils'
const taskForm = {
  id: null,
  declareCode: null,
  classify: null,
  classifyTemp: [],
  endDate: null,
  operatorId: null,
  schoolCode: null,
  startDate: null,
  teacherId: null,
  teacherName: null,
  teacherTemp: null,
  declareDate: null,
  title: null,
  attaches: []
}
export default {
  components: {
    DicSelector,
    AuthorSelector,
    Pagination,
    Uploader
  },
  name: 'teachingTask',
  data() {
    var checkDescFun = (rule, value, callback) => {
      if (this.elCheckForm.checkStatus == 2 && (value == '' || value == null)) {
        callback(new Error('请输入驳回理由'))
      } else {
        callback()
      }
    }
    return {
      classifyList: [],
      selection: [],
      checkStatusList: [],
      loading: false,
      pageLoading: false,
      saving: false,
      tableData: [],
      pointDeclareForm: taskForm,
      dialogNewPointDeclare: false,
      dialogCheck: false,
      filterForm: {
        keyword: null,
        checkStatus: null,
        queryDate: null,
        size: 10,
        current: 1,
        total: 0,
        infoCode: []
      },
      elCheckForm: {
        checkStatus: null,
        checkDesc: null
      },
      checkData: {
        id: null,
        declareDate: null,
        attaches: [],
        teacherName: null,
        createTime: null,
        score: null,
        declareTitle: null,
        title: null
      },
      rules: {
        classifyTemp: [
          { required: true, message: '请选择申报项目', trigger: 'change' }
        ],
        teacherTemp: [
          { required: true, message: '请选择申报人', trigger: 'change' }
        ],
        declareDate: [
          { required: true, message: '请选择项目申报日期', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入项目名称', trigger: 'change' }
        ],
        attaches: [
          { required: true, message: '请上传项目证明', trigger: 'change' }
        ],
        checkStatus: [
          { required: true, message: '请选择审批状态', trigger: 'change' }
        ],
        checkDesc: [
          {
            validator: checkDescFun,
            message: '请输入驳回理由',
            trigger: 'change'
          }
        ]
      }
    }
  },
  computed: {
    ...mapState(['userInfo', 'isAdmin']),
    ...mapGetters(['schoolCode', 'operatorId', 'schoolCodes'])
  },
  mounted() {
    this.getData()
  },
  created() {
    this.getDic()
  },
  methods: {
    toExport() {
      this.pageLoading = true
      this.$axios
        .post(
          '/teacherTask/exportTeacherTask',
          this.$qs.stringify({
            schoolCodes: this.schoolCodes,
            pageNum: this.filterForm.current,
            pageSize: this.filterForm.size,
            checkStatus: this.filterForm.checkStatus
              ? this.filterForm.checkStatus.dicCode
              : null,
            keyword: this.filterForm.keyword
          }),
          {
            responseType: 'blob'
          }
        )
        .then((res) => {
          this.pageLoading = false
          let fileName = window.decodeURI(
            res.headers['content-disposition'].split('=')[1]
          )
          const url = URL.createObjectURL(res.data)
          const a = document.createElement('a')
          a.href = url
          a.download = fileName // 设置下载的文件名
          a.click()
          URL.revokeObjectURL(url)
        })
        .catch(() => {
          this.pageLoading = false
        })
    },
    onAdd() {
      this.dialogNewPointDeclare = true
      if (this.userInfo.roleCodes == 'teacher') {
        this.pointDeclareForm.teacherTemp = {
          userId: this.userInfo.userId,
          userName: this.userInfo.userName
        }
      }
    },
    power,
    getDic() {
      getData('/declare/getDeclareTitleList', {
        schoolCode: this.schoolCode
      }).then((res) => {
        this.classifyList = res
        console.log(res)
      })
    },
    onSelectionChange(val) {
      this.selection = val
    },
    onCheckStatusLoaded(list) {
      this.checkStatusList = list
    },
    checkStatusFormatter(cellValue) {
      let result = cellValue
      let find = this.checkStatusList.find((f) => f.dicCode == cellValue)
      if (find) {
        result = find.dicName
      }
      return result
    },
    ondialogNewPointDeclareClose() {
      this.$refs.elpointDeclareForm.resetFields()
    },
    ondialogCheckClose() {
      this.$refs.elCheckForm.resetFields()
    },
    refresh() {
      this.filterForm.pageNum = 1
      this.getData()
    },
    onDel(row) {
      this.saving = true
      postJson('/declare/deleteScoreDeclareInfo', {
        id: row.id,
        operatorId: this.operatorId
      })
        .then((res) => {
          this.getData()
          this.$message.success('删除成功！')
        })
        .catch((e) => {})
        .finally(() => {
          this.saving = false
        })
    },
    getData() {
      this.loading = true
      postJson('/declare/getScoreDeclareInfoList', {
        schoolCode: this.schoolCode,
        schoolCodes: this.schoolCodes,
        pageNum: this.filterForm.current,
        pageSize: this.filterForm.size,
        checkStatus: this.filterForm.checkStatus
          ? this.filterForm.checkStatus.dicCode
          : null,
        keyword: this.filterForm.keyword,
        queryStartDate: this.filterForm.queryDate
          ? this.filterForm.queryDate[0]
          : '',
        queryEndDate: this.filterForm.queryDate
          ? this.filterForm.queryDate[1]
          : '',
        infoCode: this.filterForm.infoCode[this.filterForm.infoCode.length - 1]
      })
        .then((res) => {
          this.tableData = res.records
          this.filterForm.size = res.size
          this.filterForm.total = res.total
          this.filterForm.current = res.current
        })
        .catch((e) => {
          this.tableData = []
        })
        .finally(() => {
          this.loading = false
        })
    },
    onCheck(row) {
      this.checkData.attaches = row.attaches[0].url
      this.checkData.teacherName = row.teacherName
      this.checkData.declareDate = row.declareDate
      this.checkData.title = row.title
      this.checkData.createTime = row.createTime
      this.checkData.score = row.score
      this.checkData.id = row.id
      this.checkData.declareTitle = row.declareTitle
      this.dialogCheck = true
      this.elCheckForm.checkStatus = row.checkStatus + ''
      this.elCheckForm.checkDesc = row.checkDesc
    },
    findPathToNodeId,
    onEdit(row) {
      this.pointDeclareForm = {
        id: row.id,
        classifyTemp: findPathToNodeId(this.classifyList, row.infoCode),
        declareDate: row.declareDate,
        title: row.title,
        teacherId: row.teacherId,
        teacherName: row.teacherName,
        declareCode: row.declareCode,
        teacherTemp: {
          userId: row.teacherId,
          userName: row.teacherName
        },
        attaches: row.attaches.map((u) => ({
          ...u,
          attachName: u.name,
          attachSize: u.size,
          attachType: u.type,
          attachUrl: u.url
        }))
      }
      this.dialogNewPointDeclare = true
    },
    onSaveCheck() {
      this.$refs.elCheckForm.validate((valid) => {
        if (valid) {
          this.saving = true
          postJson('/declare/checkScoreDeclareInfo', {
            id: this.checkData.id,
            operatorId: this.operatorId,
            schoolCode: this.schoolCode,
            checkStatus: this.elCheckForm.checkStatus,
            checkDesc: this.elCheckForm.checkDesc,
            checkName: this.userInfo.userName
          })
            .then((res) => {
              this.dialogCheck = false
              this.$message.success('操作成功！')
              this.filterForm.pageNum = 1
              this.getData()
            })
            .catch((e) => {
              console.error(e)
            })
            .finally(() => {
              this.saving = false
            })
        }
      })
    },
    flatKey,
    onSave() {
      this.$refs.elpointDeclareForm.validate((valid) => {
        if (valid) {
          postJson('/declare/saveOrUpdateScoreDeclareInfo', {
            id: this.pointDeclareForm.id ? this.pointDeclareForm.id : null,
            declareCode: this.pointDeclareForm.declareCode
              ? this.pointDeclareForm.declareCode
              : null,
            classify: this.pointDeclareForm.classifyTemp.dicCode,
            operatorId: this.operatorId,
            schoolCode: this.schoolCode,
            teacherId: this.pointDeclareForm.teacherTemp.userId,
            teacherName: this.pointDeclareForm.teacherTemp.userName,
            attaches: this.pointDeclareForm.attaches.map((u) => ({
              ...u,
              name: u.attachName,
              size: u.attachSize,
              type: u.attachType,
              url: u.attachUrl
            })),
            title: this.pointDeclareForm.title,
            declareDate: this.pointDeclareForm.declareDate,
            declareTitle: this.pointDeclareForm.classifyTemp.reduce(
              (pre, cur, index) => {
                if (index == 0) {
                  return flatKey(this.classifyList, 'nodeList').find(
                    (f) => f.code == cur
                  )?.value
                } else {
                  return (
                    pre +
                    '/' +
                    flatKey(this.classifyList, 'nodeList').find(
                      (f) => f.code == cur
                    )?.value
                  )
                }
              },
              ''
            ),
            score: flatKey(this.classifyList, 'nodeList').find(
              (f) =>
                f.code ==
                this.pointDeclareForm.classifyTemp[
                  this.pointDeclareForm.classifyTemp.length - 1
                ]
            ).score,
            infoCode:
              this.pointDeclareForm.classifyTemp[
                this.pointDeclareForm.classifyTemp.length - 1
              ]
          })
            .then((res) => {
              this.dialogNewPointDeclare = false
              this.$message.success('操作成功！')
              this.filterForm.pageNum = 1
              this.getData()
            })
            .catch((e) => {
              console.error(e)
            })
            .finally(() => {
              this.saving = false
            })
        }
      })
    }
  }
}
</script>
<style>
.at {
  margin-left: 0 !important;
}
</style>
<style scoped>
.el-button.is-disabled.el-button--text {
  color: #c0c4cc !important;
}
</style>
